<div class="container flex flex-col items-center justify-center h-screen">
  <div class="text-center">
    <img class="w-1/2 mx-auto" src="assets/images/lens404.svg" />
    <h2>
      This page doesn't exist.
    </h2>
    <div>
      Please return to the previous page or visit
      <a href="https://getinlightened.com">GetInlightened.com</a>
    </div>
  </div>
</div>
